module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-08-d3e555169f53c2accb28d36fc3557df5.png";